import React from "react";
import {connect} from "dva";
import {component_tool,framework_tool} from '../../tool';
import {reduxTemplateConfig, templateConfig} from './config';

let {WizBrowserExport} = component_tool
let {WizContainer, WizReduxTemplate, modelUtils} = framework_tool;

class SyncEmailConfigManager extends WizContainer {
  componentName = 'SyncEmailConfigManager';

  constructor(props) {
    super(props);
    this.state={}
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '品牌',
        field: 'orgNames',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '岗位分类',
        field: 'positionCategorys',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '状态',
        field: 'state',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },
      {
        headerName: '邮箱',
        field: 'emails',
        width: 20,
        cellStyle: {
          textAlign: 'center',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'left' },
        },
      },

    ]
    if (o['success']) {
      let data = o['data']
      if(data && data instanceof Array && data.length>0){
        let stateEnum = {0: '禁用', 1: '启用'}
        data.forEach(p=>{
          p['state'] = stateEnum[p['state']]
          p['orgNames'] = p['orgList']?.map(item => item.name).join() || ''
          p['positionCategorys'] = p['positionCategoryList']?.map(item => item.name).join() || ''
          p['emails'] = p['emailList']?.join() || ''
        })
      }


      WizBrowserExport({
        title: '同步邮件分类配置',
        sheetName: '同步邮件分类配置',
        columns: columnDefs.filter((_, index) => index),
        rows: data,
        filename: '同步邮件分类配置.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }




  _render() {
    let _templateConfig = templateConfig(this)
    let _reduxTemplateConfig = reduxTemplateConfig({
      templateConfig: _templateConfig,
      apiDataFormat: {
        export: this._handleFile
      },
    });

    return (
      <WizReduxTemplate {..._reduxTemplateConfig} />
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  const { syncEmailConfig } = state;

  const list = modelUtils.getLoadingState(syncEmailConfig, ['list']);

  return {
    list
  }
};

export default connect(mapStateToProps)(SyncEmailConfigManager);
